import { Row } from '@tanstack/react-table'

import { Log, LogStatus } from '@/types/logs'
import { Role } from '@/types/auth'
import { sortLogsByTime } from './sortLogsByTime'
import { checkIsLogUrgent } from './checkIsLogUrgent'
import { checkIsLogUnfinished } from './checkIsLogUnfinished'

const isUrgentLog = (role: Role, log: Log): boolean => {
    const isUrgent = checkIsLogUrgent(log)

    if (role === Role.Controller) {
        return isUrgent
    }

    return isUrgent || checkIsLogUnfinished(log)
}

const isMechanicalInformationMissing = (log: Log): boolean =>
    !!log.codeTypeReasonInfo?.isMechanicalInfoRequired && !log.mechanicalInfo

const isOfficialReportDataMissing = (log: Log): boolean =>
    !!log.codeTypeReasonInfo?.isOfficialReportRequired && !log.report

const isMandatoryDataMissing = (log: Log): boolean => log.status === LogStatus.Incomplete

export const sortLogsByUrgency =
    (role: Role) =>
    (rowA: Row<Log>, rowB: Row<Log>): number => {
        const logA = rowA.original
        const logB = rowB.original

        if (isUrgentLog(role, logA) && !isUrgentLog(role, logB)) return -1
        if (!isUrgentLog(role, logA) && isUrgentLog(role, logB)) return 1
        if (isUrgentLog(role, logA) && isUrgentLog(role, logB)) return sortLogsByTime(logA, logB)

        if (isMechanicalInformationMissing(logA) && !isMechanicalInformationMissing(logB)) return -1
        if (!isMechanicalInformationMissing(logA) && isMechanicalInformationMissing(logB)) return 1
        if (isMechanicalInformationMissing(logA) && isMechanicalInformationMissing(logB))
            return sortLogsByTime(logA, logB)

        if (isOfficialReportDataMissing(logA) && !isOfficialReportDataMissing(logB)) return -1
        if (!isOfficialReportDataMissing(logA) && isOfficialReportDataMissing(logB)) return 1
        if (isOfficialReportDataMissing(logA) && isOfficialReportDataMissing(logB)) return sortLogsByTime(logA, logB)

        if (isMandatoryDataMissing(logA) && !isMandatoryDataMissing(logB)) return -1
        if (!isMandatoryDataMissing(logA) && isMandatoryDataMissing(logB)) return 1
        if (isMandatoryDataMissing(logA) && isMandatoryDataMissing(logB)) return sortLogsByTime(logA, logB)

        return sortLogsByTime(logA, logB)
    }
